import { Clock, Zap, ExternalLink, Sparkles } from "lucide-react";
import { PROVIDER_STYLES } from "../lib/providers";

export const FareCard = ({ offer, isCheapest, index }) => {
  const style = PROVIDER_STYLES[offer.provider] || {
    bg: "bg-zinc-900",
    text: "text-white",
    initial: offer.provider[0],
  };
  const testId = `fare-${offer.provider}-${offer.ride_type}`;
  return (
    <div
      data-testid={testId}
      className={`relative p-5 rounded-2xl border transition-all hover:-translate-y-0.5 hover:shadow-md ${
        isCheapest
          ? "bg-green-50 border-green-300"
          : "bg-white border-zinc-200 shadow-sm"
      }`}
      style={{ animationDelay: `${index * 40}ms` }}
    >
      {isCheapest && (
        <span
          data-testid={`${testId}-best-deal`}
          className="absolute -top-3 right-4 px-3 py-1 bg-green-600 text-white text-[10px] font-bold uppercase tracking-widest rounded-full shadow-sm z-10 inline-flex items-center gap-1"
        >
          <Sparkles size={10} /> Best deal
        </span>
      )}

      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <div
            className={`w-11 h-11 rounded-full flex items-center justify-center font-black text-sm shrink-0 ${style.bg} ${style.text}`}
            aria-hidden
          >
            {style.initial}
          </div>
          <div className="min-w-0">
            <div className="font-semibold text-zinc-950 truncate">{offer.provider}</div>
            <div className="text-xs text-zinc-500 uppercase tracking-wider font-semibold">
              {offer.ride_type}
            </div>
          </div>
        </div>

        <div className="text-right shrink-0">
          <div className="text-2xl font-black text-zinc-950 tracking-tight tabular-nums">
            ₹{offer.fare}
          </div>
          {offer.surge > 1.05 && (
            <div className="text-[10px] text-orange-600 font-bold uppercase tracking-wider inline-flex items-center gap-1">
              <Zap size={10} /> {offer.surge.toFixed(2)}× surge
            </div>
          )}
        </div>
      </div>

      <div className="mt-4 flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="flex items-center gap-1.5 text-xs font-medium bg-zinc-100 text-zinc-700 px-2.5 py-1 rounded-md">
            <Clock size={11} /> {offer.eta_minutes} min away
          </span>
          <span className="flex items-center gap-1.5 text-xs font-medium bg-zinc-100 text-zinc-700 px-2.5 py-1 rounded-md">
            {offer.trip_minutes} min trip
          </span>
          {offer.note && (
            <span className="text-[11px] text-zinc-500 italic">{offer.note}</span>
          )}
        </div>

        <a
          href={offer.deep_link}
          data-testid={`${testId}-book`}
          className={`px-5 py-2 rounded-full font-bold text-sm transition-transform active:scale-95 shadow-sm inline-flex items-center justify-center gap-1.5 ${style.bg} ${style.text} hover:opacity-90`}
        >
          Book <ExternalLink size={12} />
        </a>
      </div>
    </div>
  );
};
